package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.CreditUiState
import app.smartcoding.realrate.domain.model.ErrorType
import app.smartcoding.realrate.localization.LocalStrings

@Composable
fun Error(
    error: CreditUiState.Error
) {
    val errorMessage = when (error.error) {
        is ErrorType.PaymentLessThanLoan -> LocalStrings.current.errorTotalPaymentIsLessThanLoanAmount
        is ErrorType.CalculationOverflow -> LocalStrings.current.errorCalculationOverflow
        ErrorType.DivisionByZero -> LocalStrings.current.errorDivisionByZero
        ErrorType.NegativeResult -> LocalStrings.current.errorNegativeResult
        ErrorType.RateTooHigh -> LocalStrings.current.errorRateTooHigh
        ErrorType.CalculationError -> LocalStrings.current.errorCalculation
    }

    Card(
        modifier = Modifier.height(248.dp),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.errorContainer
        )
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Icon(
                imageVector = Icons.Default.Warning,
                contentDescription = null,
                modifier = Modifier.size(96.dp),
                tint = MaterialTheme.colorScheme.error
            )
            Spacer(Modifier.height(16.dp))
            Text(
                text = errorMessage,
                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.titleLarge,
                textAlign = TextAlign.Center
            )
        }
    }
}